<template>
  <div class="ibox-body">
    <div class="ibox-title style_2">
      <h5>{{ title }}</h5>
    </div>

    <!-- LOADING -->
    <div class="text-center fixedheight" v-if="loading === true">
      <img src="../../assets/img/loading.gif" width="15" alt="Waiting for login" />
      <div>{{ $t("navigations.please wait while the list is being loaded") }}</div>
    </div>

    <div v-else class="ibox-content fixedheight horizondalscroll" id="scrollBody">
      <ul class="tree pl-1">
        <template v-for="(node, nodeIndex) in visitTreeList"
          :key="`visit-node-${node?.type || 'unknown'}-${node?.visit?.visitId || node?.cycleId || nodeIndex}`">
          <li v-if="node && node.type === 'visit'">

            <div class="d-flex justify-content-between align-items-center">

              <div class="w-100">
                <input type="checkbox" :id="node.visit.visitId"
                  @change="toggleVisit(node.visit.__visitIndex, node.visit.visitId)" />

                <label class="tree_label" :for="node.visit.visitId">
                  {{ node.visit.visitNo }} : {{ node.visit.visitFormName }}
                </label>
              </div>

              <!-- ACTION ICONS -->
              <div class="d-flex align-items-center gap-3" v-if="optionsshow">

                <!-- 3 dots menu -->
                <div class="position-relative">
                  <button :popovertarget="'visit-popup-' + node.visit.visitId"
                    :anchor="'visit-popup-' + node.visit.visitId"
                    class="tmf-doc-ellipsis-btn border-0 bg-transparent cursor-pointer px-2 py-0 pt-2">
                    <i class="fa fa-ellipsis-v"></i>
                  </button>

                  <div :id="'visit-popup-' + node.visit.visitId" popover class="tmf-docs-popup-menu" @click.stop>
                  <button class="popup-menu-block text-start" v-if="!isVisitActivated(node.visit)"
                            @click.prevent="openCreateSchedule(node.visit.visitId, node.visit.visitFormName)">
                            {{ $t('navigations.activate') }}
                          </button>
                          <span 
                            v-else 
                            class="col-lg-12 d-flex justify-content-center align-items-center" >
                            {{ $t('navigations.nothing to show') }}
                          </span>
                  </div>
                </div>

              </div>
            </div>
            <div v-if="visitExpanded[node.visit.__visitIndex]">
              <ul v-for="(activity, aIndex) in activityList[node.visit.visitId][node.visit.__visitIndex]"
                :key="activity.activityId">
                <li>
                  <input type="checkbox" :id="activity.activityId + node.visit.visitId"
                    @change="getActivityForms(activity.activityId, aIndex)" />

                  <label :for="activity.activityId + node.visit.visitId" class="tree_label">
                    {{ activity.activityOrder }} : {{ activity.activityName }}
                  </label>

                  <!-- FORMS -->
                  <ul v-for="form in formList[activity.activityId][aIndex]" :key="form.templateId">
                    <li>
                      <label :for="form.templateId" class="tree_form">
                        <!-- {{ form.templateName }} : {{ form.version }} -->
                        {{ form.templateName }} ( {{ form.version }}) - {{ form.languageCode.toUpperCase() }}
                      </label>

                      <input type="checkbox" :id="form.templateId" @change="viewForms(form.templateId)" />
                    </li>
                  </ul>

                </li>
              </ul>
            </div>

          </li>
          <li v-else-if="node && node.type === 'phase'">

            <input type="checkbox" :id="'phase-' + node.phaseName" />

            <label class="tree_label" :for="'phase-' + node.phaseName">
              {{ node.displayText }}
            </label>

            <ul>
              <template v-for="child in node.nodes" :key="child.visit?.visitId || child.cycleId">

                <!-- VISIT INSIDE PHASE -->
                <li v-if="child.type === 'visit'">

                  <!-- Visit Header -->
                  <div class="d-flex justify-content-between align-items-center">

                    <div class="w-100">
                      <input type="checkbox" :id="child.visit.visitId"
                        @change="toggleVisit(child.visit.__visitIndex, child.visit.visitId)" />

                      <label class="tree_label" :for="child.visit.visitId">
                        {{ child.visit.visitNo }} : {{ child.visit.visitFormName }}
                      </label>
                    </div>

                    <!-- ACTION ICONS -->
                    <div class="d-flex align-items-center gap-3" v-if="optionsshow">

                      <div class="position-relative">
                        <button :popovertarget="'visit-popup-' + child.visit.visitId"
                          :anchor="'visit-popup-' + child.visit.visitId"
                          class="tmf-doc-ellipsis-btn border-0 bg-transparent cursor-pointer px-2 py-0 pt-2">
                          <i class="fa fa-ellipsis-v"></i>
                        </button>

                        <div :id="'visit-popup-' + child.visit.visitId" popover class="tmf-docs-popup-menu" @click.stop>

                          <button class="popup-menu-block text-start" v-if="!isVisitActivated(child.visit)"
                            @click.prevent="openCreateSchedule(child.visit.visitId, child.visit.visitFormName)">
                            {{ $t('navigations.activate') }}
                          </button>
                          <span 
                            v-else 
                            class="col-lg-12 d-flex justify-content-center align-items-center" >
                            {{ $t('navigations.nothing to show') }}
                          </span>

                        </div>
                      </div>

                    </div>
                  </div>

                  <!-- ACTIVITIES -->
                  <div v-if="visitExpanded[child.visit.__visitIndex]">

                    <ul v-for="(activity, aIndex) in activityList[child.visit.visitId][child.visit.__visitIndex]"
                      :key="activity.activityId">

                      <li>

                        <input type="checkbox" :id="activity.activityId + child.visit.visitId"
                          @change="getActivityForms(activity.activityId, aIndex)" />

                        <label :for="activity.activityId + child.visit.visitId" class="tree_label">
                          {{ activity.activityOrder }} : {{ activity.activityName }}
                        </label>

                        <!-- FORMS -->
                        <ul v-for="form in formList[activity.activityId][aIndex]" :key="form.templateId">

                          <li>

                            <label :for="form.templateId" class="tree_form">
                              <!-- {{ form.templateName }} : {{ form.version }} -->
                              {{ form.templateName }} ( {{ form.version }}) - {{ form.languageCode.toUpperCase() }}
                            </label>

                            <input type="checkbox" :id="form.templateId" @change="viewForms(form.templateId)" />

                          </li>

                        </ul>
                      </li>

                    </ul>

                  </div>

                </li>

                <!-- CYCLE INSIDE PHASE -->
                <li v-else-if="child.type === 'cycle'">

                  <input type="checkbox" :id="'cycle-' + child.cycleId" />

                  <label class="tree_label" :for="'cycle-' + child.cycleId">
                    {{ child.displayText }}
                  </label>

                  <ul>

                    <li v-for="visit in child.visits" :key="visit.visitId">

                      <div class="d-flex justify-content-between align-items-center">

                        <div>
                          <input type="checkbox" :id="visit.visitId"
                            @change="toggleVisit(visit.__visitIndex, visit.visitId)" />

                          <label class="tree_label" :for="visit.visitId">
                            {{ visit.visitNo }} : {{ visit.visitFormName }}
                          </label>
                        </div>
                        <div class="d-flex align-items-center gap-3" v-if="optionsshow">
                          <div class="position-relative">
                            <button :popovertarget="'visit-popup-' + visit.visitId"
                              :anchor="'visit-popup-' + visit.visitId"
                              class="tmf-doc-ellipsis-btn border-0 bg-transparent cursor-pointer px-2 py-0 pt-2">
                              <i class="fa fa-ellipsis-v"></i>
                            </button>

                            <div :id="'visit-popup-' + visit.visitId" popover class="tmf-docs-popup-menu" @click.stop>

                              <button class="popup-menu-block text-start" v-if="!isVisitActivated(visit)"
                                @click.prevent="openCreateSchedule(visit.visitId, visit.visitFormName)">
                                {{ $t('navigations.activate') }}
                              </button>
                              <span 
                                v-else 
                                class="col-lg-12 d-flex justify-content-center align-items-center" >
                                {{ $t('navigations.nothing to show') }}
                              </span>

                            </div>
                          </div>
                        </div>

                      </div>

                      <!-- ACTIVITIES -->
                      <div v-if="visitExpanded[visit.__visitIndex]">

                        <ul v-for="(activity, aIndex) in activityList[visit.visitId][visit.__visitIndex]"
                          :key="activity.activityId">

                          <li>

                            <input type="checkbox" :id="activity.activityId + visit.visitId"
                              @change="getActivityForms(activity.activityId, aIndex)" />

                            <label :for="activity.activityId + visit.visitId" class="tree_label">
                              {{ activity.activityOrder }} : {{ activity.activityName }}
                            </label>

                            <ul v-for="form in formList[activity.activityId][aIndex]" :key="form.templateId">

                              <li>

                                <label :for="form.templateId" class="tree_form">
                                  {{ form.templateName }} ( {{ form.version }}) - {{ form.languageCode.toUpperCase() }}
                                  <!-- {{ form.templateName }} : {{ form.version }} -->
                                </label>

                                <input type="checkbox" :id="form.templateId" @change="viewForms(form.templateId)" />

                              </li>

                            </ul>

                          </li>

                        </ul>

                      </div>

                    </li>

                  </ul>



                </li>

              </template>

            </ul>
          </li>
          <li v-else-if="node && node.type === 'cycle'">
            <input type="checkbox" :id="`cycle-${node.cycleId || 'unknown'}-${nodeIndex}`" />
            <label class="tree_label" :for="`cycle-${node.cycleId || 'unknown'}-${nodeIndex}`">
              {{ node.displayText }}
            </label>
            <span v-if="hasRepeatCycleSubject" class="position-relative cursor-pointer float-right px-2"
              @click.prevent="toggleCycleSidePopup(nodeIndex)" v-on:clickout="closeCycleSidePopup(nodeIndex)">
              <i class="fa fa-ellipsis-v"></i>
            </span>
            <div class="plan-side-popup" v-if="hasRepeatCycleSubject && showCycleSidePopup[nodeIndex]">
              <div @click.prevent="openScheduleCyclePopup(node.cycleId)">
                Repeat Cycle
              </div>
            </div>

            <ul>
              <li v-for="visit in node.visits" :key="visit.visitId">

                <div class="d-flex justify-content-between align-items-center">

                  <div>
                    <input type="checkbox" :id="visit.visitId"
                      @change="toggleVisit(visit.__visitIndex, visit.visitId)" />

                    <label class="tree_label" :for="visit.visitId">
                      {{ visit.visitNo }} : {{ visit.visitFormName }}
                    </label>
                  </div>
                  <div class="d-flex align-items-center gap-3" v-if="optionsshow">
                    <div class="position-relative">
                      <button :popovertarget="'visit-popup-' + visit.visitId" :anchor="'visit-popup-' + visit.visitId"
                        class="tmf-doc-ellipsis-btn border-0 bg-transparent cursor-pointer px-2 py-0 pt-2">
                        <i class="fa fa-ellipsis-v"></i>
                      </button>

                      <div :id="'visit-popup-' + visit.visitId" popover class="tmf-docs-popup-menu" @click.stop>
                        <button class="popup-menu-block text-start" v-if="!isVisitActivated(visit)"
                          @click.prevent="openCreateSchedule(visit.visitId, visit.visitFormName)">
                          {{ $t('navigations.activate') }}
                        </button>
                       <span 
                          v-else 
                          class="col-lg-12 d-flex justify-content-center align-items-center" 
                        >
                            {{ $t('navigations.nothing to show') }}
                        </span>

                      </div>
                    </div>

                  </div>
                </div>

                <div v-if="visitExpanded[visit.__visitIndex]">
                  <ul v-for="(activity, aIndex) in activityList[visit.visitId][visit.__visitIndex]"
                    :key="activity.activityId">
                    <li>
                      <input type="checkbox" :id="activity.activityId + visit.visitId"
                        @change="getActivityForms(activity.activityId, aIndex)" />

                      <label :for="activity.activityId + visit.visitId" class="tree_label">
                        {{ activity.activityOrder }} : {{ activity.activityName }}
                      </label>

                      <!-- FORMS -->
                      <ul v-for="form in formList[activity.activityId][aIndex]" :key="form.templateId">
                        <li>
                          <label :for="form.templateId" class="tree_form">
                            {{ form.templateName }} ( {{ form.version }}) - {{ form.languageCode.toUpperCase() }}
                            <!-- {{ form.templateName }} : {{ form.version }} -->
                          </label>

                          <input type="checkbox" :id="form.templateId" @change="viewForms(form.templateId)" />
                        </li>
                      </ul>

                    </li>
                  </ul>
                </div>

              </li>
            </ul>
          </li>
        </template>
      </ul>
    </div>
  </div>

  <!-- MODALS -->
  <showformmodel v-if="setshowActivityFormModal" :formid="formActivityId" currentformstatus="not completed"
    @closeformModal="closeformActivityModal()" />

  <VisitActivityModal v-if="showActivityModal" :visitId="SelectedVisitId" :version="selectedVersion"
    @closeModal="closeActivityModal()" />

  <manageVisitModal v-if="showSiteModal" :visitId="visitId" :version="selectedVersion" @closeModal="closeModal()"
    @visitSaved="openVisitActivityModal" />

  <CreateScheduleCyclePopUp v-if="CreateScheduleCyclePopUp" @closeModal="CreateScheduleCyclePopUp = false"
    :patientid="selectedPatientId" :cycleid="selectedCycleId" />
  <createVisitSchedulePopup v-if="showCreateSchedule" @closeModal="closeCreateSchedule()" :visitId="visitId"
    :visitName="visitName" :subjectId="subjectId" />
</template>

<script src="./SoaTree.js"></script>

<style scoped>
.horizondalscroll {
  overflow-y: auto;
  max-height: 500px;
}
.fixedheight{
  min-height: 150px;
}
.tmf-docs-popup-menu {
  position: absolute;
  inset: auto;
  text-align: left;
  border-radius: 5px;
  border: 1px solid #e7eaec;
  background-color: rgba(255, 255, 255, 1);
  box-shadow: 3px 3px 3px rgba(160, 160, 160, 0.5);
  z-index: 200;
}

.tmf-docs-popup-menu {
  top: anchor(bottom);
  right: anchor(left);
  width: fit-content;
  margin-inline-end: 5px;
}

.tmf-docs-popup-menu {
  position-try-fallbacks: --bottom;
  top: anchor(bottom);
  right: anchor(right);
  width: 160px;
}

.tmf-docs-popup-menu>button {
  width: 100%;
  border: 0;
  font-size: 0.8rem;
  font-weight: 400;
  color: rgba(0, 0, 0);
  padding: 0.6rem 0.8rem;
}

[popover]:popover-open {
  display: flex;
  flex-direction: column;
  align-items: baseline;
  animation: fadeIn 0.2s ease-in-out;
}

.tmf-docs-popup-menu>.popup-menu-block:hover {
  background-color: #e4eaf9;
}

.position-relative .tool-tip {
  width: max-content;
  background-color: #616161;
  color: #fff;
  text-align: center;
  border-radius: 0.3em;
  padding: 0.1rem 0.8rem;
  right: 20px;
  top: -10px;
  font-size: 0.8rem;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
  -webkit-transition: visibility 75ms ease-in;
  transition: visibility 75ms ease-in;
}

</style>
